module.exports = __webpack_public_path__ + "img/img2.9b198c52.png";